import React, { createContext, FC, useEffect, useState, Context } from 'react';
import Api from '../services/Api';
import Loading from '../components/Loading';
import { cloneDeep } from 'lodash';

export interface IAppContext {
	assets?: any;
	Api: any;
}

export interface IAppContextProps {
	assets?: any;
	api_map?: any;
}

export const AppContext = createContext({} as IAppContext);

const withAppContext = function <T>(
	Component: FC<T & { context: Context<IAppContext> } & IAppContextProps>,
) {
	return (props: T & IAppContextProps) => {
		const [ready, setReady] = useState(false);
		const { assets, api_map, ...otherProps } = props;
		const [apiInstance] = useState(cloneDeep(Api));

		useEffect(() => {
			if (api_map) {
				// If we already have a map, then apply it, saving the call to the server.
				apiInstance.applyMap(api_map);
			} else {
				// @ts-ignore
				if (window?.TBK_APP_CONTEXT?.api_map) {
					// @ts-ignore
					apiInstance.applyMap(window.TBK_APP_CONTEXT.api_map);
				}
			}
			// @ts-ignore
			apiInstance.prepare().then(() => setReady(true));
		}, [apiInstance, api_map]);

		const context = {
			assets,
			Api: apiInstance,
		};

		// An interesting thing here.  Without the <div> wrapper, the way tbk-gutenberg renders this component
		// causes "DOMException: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of
		// this node" because this component is appended to an element that gets replaced.  Having the div at the top
		// means that the component is mounted to that, which is still there after tbk-gutenberg has done the replace.
		// A new pattern to remember....
		return (
			<div>
				<AppContext.Provider value={context}>
					{ready ? (
						/* @ts-ignore JSX element type 'Component' does not have any construct or call signatures. */
						<Component {...otherProps} context={AppContext} />
					) : (
						<Loading />
					)}
				</AppContext.Provider>
			</div>
		);
	};
};

export default withAppContext;
